// Tremor Raw cx [v0.0.0]

import clsx, { type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cx(...args: ClassValue[]) {
  return twMerge(clsx(...args))
}

// Tremor Raw focusInput [v0.0.1]
//
// Abweichung vom Original, abgestimmt („Feinschliff"): Tremor legt einen 2px
// breiten Ring in `blue-200` an. Seit dem Markenwechsel ist das ein helles
// Türkis — ein bunter Streifen, der neben dem Feld steht statt aus ihm heraus
// zu wachsen. Der Ring ist deshalb aus der Akzentfarbe selbst getönt und stark
// durchscheinend: breiter (3px), aber leiser. Der Rahmen darunter trägt die
// Aussage, der Ring nur die Aufmerksamkeit.
//
// Im dunklen Theme braucht derselbe Effekt mehr Deckkraft — auf `gray-925`
// verschwinden 15 % Türkis, auf Weiß sind sie deutlich genug.

export const focusInput = [
  // base
  "focus:ring-[3px]",
  // ring color
  "focus:ring-blue-500/15 focus:dark:ring-blue-400/25",
  // border color
  "focus:border-blue-500 focus:dark:border-blue-500",
]

// Tremor Raw focusRing [v0.0.1]
//
// Bleibt eine echte `outline`: Sie folgt der Form des Elements, überlebt
// `overflow-hidden` nicht als Schatten und ist die einzige Variante, die
// Windows' Kontrastmodus zuverlässig durchreicht. Nur der Abstand ist von 2px
// auf 1px zurückgenommen — bei 8px Radius saß der Ring sonst sichtbar neben
// der Ecke statt an ihr.

export const focusRing = [
  // base
  "outline outline-offset-1 outline-0 focus-visible:outline-2",
  // outline color
  "outline-blue-500 dark:outline-blue-500",
]

// Tremor Raw hasErrorInput [v0.0.1]
// Dieselbe Behandlung wie beim Fokus, damit Fehler und Fokus nicht in zwei
// verschiedenen Formsprachen sprechen.

export const hasErrorInput = [
  // base
  "ring-[3px]",
  // border color
  "border-red-500 dark:border-red-500",
  // ring color
  "ring-red-500/15 dark:ring-red-500/25",
]

export const formatters: { [key: string]: any } = {
  currency: ({
    number,
    maxFractionDigits = 2,
    currency = "USD",
  }: {
    number: number
    maxFractionDigits?: number
    currency?: string
  }) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currency,
      maximumFractionDigits: maxFractionDigits,
    }).format(number),

  unit: (number: number) => {
    const formattedNumber = new Intl.NumberFormat("en-US", {
      style: "decimal",
    }).format(number)
    return `${formattedNumber}`
  },

  percentage: ({
    number,
    decimals = 1,
  }: {
    number: number
    decimals?: number
  }) => {
    const formattedNumber = new Intl.NumberFormat("en-US", {
      style: "percent",
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    }).format(number)
    const symbol = number > 0 && number !== Infinity ? "+" : ""

    return `${symbol}${formattedNumber}`
  },

  million: ({
    number,
    decimals = 1,
  }: {
    number: number
    decimals?: number
  }) => {
    const formattedNumber = new Intl.NumberFormat("en-US", {
      style: "decimal",
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    }).format(number)
    return `${formattedNumber}M`
  },
}
